<template>
  <div>
    <cpxlist :status='3'/>
  </div>
</template>

<script>
import cpxlist from '@/components/cpx/cpxlist';
export default {
    name:'cpxend',
    components:{
      cpxlist,
    }
}
</script>

<style>

</style>